export class CreditCardModel
{
  isValid: boolean;
    public name:string = "";
    public number:string = "";
    public expiry:string ="";
    public cvc:string = "";
}
